export enum BobFreshFoodType {
    fixed,
    relative
}